import React from 'react'
import {formatPrice} from '../../lib/currency'
import {replace} from '../../lib/template'
import {BlockComponentProps} from '../index'
import {Font} from '../../lib/font'
import {BlockBase} from '../base'
import {ButtonBase} from '../Button/ButtonBase'
import {Body as ButtonContent} from '../Button/Content'
import {Column} from '../../lib/layout'
import styles from './UpsellPurchaseButton.module.css'
import {usePurchase} from '../../PurchaseContext'
import Container from '../Container'

export interface UpsellPurchaseButtonBlock extends BlockBase {
  type: 'UpsellPurchaseButton'
  text: string
  size: Column
  font: Font | null
  fontSize?: number
  backgroundColor?: string
  hoverBackgroundColor?: string
  textColor?: string
  hoverTextColor?: string
  borderRadius?: number
  borderWidth?: number
  borderColor?: string
  hoverBorderColor?: string
  height?: number
  width?: number
  disabledBackgroundColor?: string
  disabledTextColor?: string
}

export default function UpsellPurchaseButton(
  props: UpsellPurchaseButtonBlock & BlockComponentProps,
) {
  const {padding: _padding, ...buttonProps} = props

  const {upsellPurchase} = usePurchase()

  const text = useTextWithTicketVariables(buttonProps.text)

  return (
    <Container {...props}>
      <ButtonBase
        {...buttonProps}
        className={styles.upsellPurchaseButton}
        type="button"
        id={`upsell-purchase-button-${props.id}`}
        onClick={upsellPurchase}
      >
        <ButtonContent {...props} text={text} type="Button" />
      </ButtonBase>
    </Container>
  )
}

function useTextWithTicketVariables(text: string) {
  const {upsellTicket} = usePurchase()

  if (!upsellTicket) {
    return text
  }

  const attributes = {
    ticket_name: upsellTicket.name,
    ticket_price: `$${formatPrice(upsellTicket.price)}`,
  }
  let result = text
  // Replace attributes we know about.
  for (const [key, value] of Object.entries(attributes)) {
    result = replace(key, String(value), result)
  }
  return result
}
